import { useMemo, useRef, useState } from 'react';
import { useAuth } from 'src/contexts/auth';
import { useData } from 'src/contexts/data';
import { ModelOfContractBidding, ModelOfUnityContract } from 'src/database';
import api from 'src/services/api';

export const useListUnityContractsController = () => {
	const { currentBidding, selectedBudgetUnit, selectedContractBidding, getBudgetUnits, setSelectedContractBidding } =
		useData();

	const [loading, setLoading] = useState(false);
	const [biddingContracts, setBiddingContracts] = useState<ModelOfContractBidding[]>([]);
	const [removableBiddingContract, setRemovableBiddingContract] = useState<ModelOfContractBidding | null>(null);
	const [removableBudgetUnit, setRemovableBudgetUnit] = useState<ModelOfUnityContract | null>(null);
	const [biddingContractRemoveDialog, setBiddingContractRemoveDialog] = useState(false);
	const [budgetUnitRemoveDialog, setBudgetUnitRemoveDialog] = useState(false);

	const { userAgencyId } = useAuth();

	const toast: any = useRef();

	const getBiddingContracts = () => {
		setLoading(true);
		api.get(`bidding-contract/${selectedBudgetUnit?.ID}`)
			.then((response) => {
				setBiddingContracts(
					response.data.filter((item: any) => {
						return item.ORGAO === userAgencyId;
					})
				);
				setLoading(false);
			})
			.catch((err) => {
				console.log(err);
				setLoading(false);
			});
	};

	useMemo(() => {
		getBiddingContracts();
	}, [selectedBudgetUnit?.ID, selectedContractBidding]);

	const openBudgetUnitRemoveDialog = (budgetUnit: ModelOfUnityContract) => {
		setRemovableBudgetUnit(budgetUnit);
		setBudgetUnitRemoveDialog(true);
	};

	const closeBudgetUnitRemoveDialog = () => {
		setBudgetUnitRemoveDialog(false);
	};

	const openBiddingContractRemoveDialog = (biddingContract: ModelOfContractBidding) => {
		setRemovableBiddingContract(biddingContract);
		setBiddingContractRemoveDialog(true);
	};

	const closeBiddingContractRemoveDialog = () => {
		setBiddingContractRemoveDialog(false);
	};

	const removeContractBiddings = (contract: ModelOfContractBidding) => {
		setLoading(true);
		api.delete(`bidding-contract/${contract?.ID}`)
			.then(() => {
				getBiddingContracts();
				sessionStorage.removeItem('@selectedContractBidding');
				setSelectedContractBidding(null);
				setBiddingContractRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Contrato removido',
					detail: 'O contrato foi removido com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				console.log(err);
				setBiddingContractRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Contrato não removido',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	const removeBudgetUnit = (budgetUnit: ModelOfUnityContract) => {
		setLoading(true);
		api.delete(`contracts/${budgetUnit?.ID}`)
			.then(() => {
				getBudgetUnits(currentBidding?.ID);
				setBudgetUnitRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'success',
					summary: 'Unidade removida',
					detail: 'A unidade foi removida com sucesso!',
					life: 5000,
				});
			})
			.catch((err) => {
				console.log(err);
				getBudgetUnits(currentBidding?.ID);
				setBudgetUnitRemoveDialog(false);
				setLoading(false);
				toast.current.show({
					severity: 'error',
					summary: 'Unidade não removida',
					detail: 'Falha ao realizar operação!',
					life: 5000,
				});
			});
	};

	return {
		getListUnityContracts: {
			loading,
			biddingContracts,
			toast,
			removableBudgetUnit,
			removableBiddingContract,
			budgetUnitRemoveDialog,
			biddingContractRemoveDialog,
		},
		handleListUnityContractController: {
			getBiddingContracts,
			removeBudgetUnit,
			removeContractBiddings,
			openBudgetUnitRemoveDialog,
			closeBudgetUnitRemoveDialog,
			openBiddingContractRemoveDialog,
			closeBiddingContractRemoveDialog,
		},
	};
};
